import { ChevronLeft, ChevronRight } from "lucide-react"
import { Button } from "./Button/Button"
import { useLangContext } from "context/Lang"


type PaginationProps = {
    page: number
    totalPages: number
    onChange: (newPage: number) => void
}

const getPageNumbers = (page: number, totalPages: number) => {
    const pages: (number | string)[] = []

    // Always show first 2
    for (let i = 1; i <= Math.min(2, totalPages); i++) {
        pages.push(i)
    }

    // Left dots
    if (page > 4) {
        pages.push("...")
    }

    // Pages around current (2 before & after)
    for (let i = page - 2; i <= page + 2; i++) {
        if (i > 2 && i < totalPages - 1) {
            pages.push(i)
        }
    }

    // Right dots
    if (page < totalPages - 3) {
        pages.push("...")
    }

    // Always show last 2
    for (let i = Math.max(totalPages - 1, 3); i <= totalPages; i++) {
        pages.push(i)
    }

    return pages
}

export const Pagination = ({ page, totalPages, onChange }: PaginationProps) => {

    const { gW } = useLangContext();

    if (totalPages < 1) return null


    const pages = getPageNumbers(page, totalPages)

    return (
        <div className="flex items-center justify-end ">
            <div className="flex items-center gap-2">
                {/* Previous */}
                <Button
                    variant="outline"
                    size="sm"
                    onClick={() => onChange(page - 1)}
                    disabled={page <= 1}
                    className="border-border      hover:bg-background-secondary"
                >
                    {/* {gW("previous")} */}
                    <ChevronLeft className="w-4 h-4" />

                </Button>

                {/* Page Numbers */}
                <div className="flex items-center gap-1">
                    {pages.map((p, idx) =>
                        p === "..." ? (
                            <span key={`dots-${idx}`} className="px-2 ">
                                ...
                            </span>
                        ) : (
                            <Button
                                key={p}
                                variant={p === page ? "solid" : "outline"}
                                size="sm"
                                onClick={() => onChange(Number(p))}
                                className={`w-8 h-8 p-0 `}
                            >

                                {p}
                            </Button>
                        )
                    )}
                </div>

                {/* Next */}
                <Button
                    variant="outline"
                    size="sm"
                    onClick={() => onChange(page + 1)}
                    disabled={page >= totalPages}
                    className="border-border hover:bg-background-secondary"
                >
                    {/* {gW("next")} */}
                    <ChevronRight className="w-4 h-4" />
                </Button>
            </div>
        </div>
    )
}